// extracted by mini-css-extract-plugin
module.exports = {"Container":"Title_Container__XnB-Z"};